import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { getUserNotificationsGQL, meGQL } from "../../../graphql";

export const useRefetchNotification = () => {
  const { data: dataMe } = useQuery(meGQL);
  const { data, refetch: refetchUserNotifications } = useQuery(
    getUserNotificationsGQL,
    {
      variables: {
        userId: dataMe?.me?.id,
        product: "tgp",
      },
      skip: !dataMe?.me?.id,
    },
  );

  // Fetching notification every 1 hour
  useEffect(() => {
    const interval = setInterval(() => {
      refetchUserNotifications();
    }, 3600000);
    return () => clearInterval(interval);
  }, [refetchUserNotifications]);

  return {
    notifications: data?.user?.notifications,
    refetchUserNotifications,
    language: data?.me?.language,
  };
};
